import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { ref, watch } from 'vue'
import isNil from 'lodash/isNil'

import EditableTableColumn from './EditableTableColumn.vue'

interface Props {
  sourceValue: string | null
  success: boolean
  loading?: boolean
  editable?: boolean
  maxLength?: number
  showWordLimit?: boolean
  type?: string
  upCase?: boolean
}

interface Emits {
  (e: 'save', value: string): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditableInput',
  props: {
    sourceValue: {},
    success: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    editable: { type: Boolean, default: true },
    maxLength: {},
    showWordLimit: { type: Boolean },
    type: {},
    upCase: { type: Boolean }
  },
  emits: ["save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isEditingMode = ref(false)

const getInitialValue = () =>
  isNil(props.sourceValue) ? '' : props.sourceValue

const value = ref<string>(getInitialValue())

watch(
  () => props.success,
  (newValue, prevValue) => {
    // changed from `false` to `true` means that updating action was success
    if (!prevValue && newValue) isEditingMode.value = false
  }
)

const handleEditPress = () => {
  isEditingMode.value = true
}

const handleSavePress = () => {
  emit('save', value.value)
}

const handleCancelPress = () => {
  isEditingMode.value = false
  value.value = getInitialValue()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(EditableTableColumn, {
      editable: _ctx.editable,
      sourceValue: _ctx.sourceValue,
      saveLoading: _ctx.loading,
      isEditingMode: isEditingMode.value,
      saveDisabled: !value.value,
      onEditClick: handleEditPress,
      onSaveClick: handleSavePress,
      onCancelClick: handleCancelPress
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
          size: "small",
          maxlength: _ctx.maxLength,
          "show-word-limit": _ctx.showWordLimit,
          type: _ctx.type,
          rows: _ctx.type === 'textarea' ? 8 : undefined,
          onInput: _cache[1] || (_cache[1] = v => (value.value = _ctx.upCase ? v.toUpperCase() : value.value))
        }, null, 8, ["modelValue", "maxlength", "show-word-limit", "type", "rows"])
      ]),
      _: 1
    }, 8, ["editable", "sourceValue", "saveLoading", "isEditingMode", "saveDisabled"])
  ]))
}
}

})